import React from 'react';
import Header from '../PartialViews/section-header';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export default function NotFound() {
    return (
        <Header>
            <Typography variant="h2" className={"wow fadeInRight"} style={{color:"wheat"}}>
                <Box fontWeight="fontWeightBold">
                    Page not found!
                </Box>
            </Typography>
        </Header>
    )
}